module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/arrow-next-white-70566abc6ac84a18af15dc98fa3d53b0.svg&quot;;"